declare global {
  interface Window {
    __chunkReloadPending?: boolean;
  }
}

export const RELOAD_GUARD_KEY = 'chunk_reload_at';
export const RELOAD_WINDOW_MS = 5 * 60 * 1000;
export const MAX_JITTER_MS = 5000;

// A blocked sessionStorage counts as "attempt spent": reloading without a guard could loop forever.
function claimReloadAttempt(): boolean {
  try {
    const lastAttemptAt = Number(
      window.sessionStorage.getItem(RELOAD_GUARD_KEY) || '0',
    );
    if (Date.now() - lastAttemptAt < RELOAD_WINDOW_MS) {
      return false;
    }
    window.sessionStorage.setItem(RELOAD_GUARD_KEY, String(Date.now()));
    return true;
  } catch {
    return false;
  }
}

// webpack names the error ChunkLoadError (still seen from tabs opened on the CRA build); Vite throws a
// TypeError whose message depends on the browser (Chrome, Firefox, Safari) or on the CSS preload.
const DYNAMIC_IMPORT_FAILURE =
  /Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed|Unable to preload CSS/i;

export function isChunkLoadError(error: unknown): boolean {
  const { name, message } = (error ?? {}) as { name?: unknown; message?: unknown };
  return (
    name === 'ChunkLoadError' ||
    (typeof message === 'string' && DYNAMIC_IMPORT_FAILURE.test(message))
  );
}

// The random delay spreads the reloads of everyone hit by the same deploy so the API does not get a burst.
export function scheduleChunkReload(): boolean {
  if (window.__chunkReloadPending) {
    return true;
  }
  if (!claimReloadAttempt()) {
    return false;
  }
  window.__chunkReloadPending = true;
  window.setTimeout(
    () => window.location.reload(),
    Math.random() * MAX_JITTER_MS,
  );
  return true;
}
